if (!customElements.get('slideshow-video')) {
  class SlideshowVideo extends HTMLElement {
    connectedCallback() {
      this.slide = this.closest('.slideshow__slide');
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.update = this.syncPlayback.bind(this);
      this.mobile.addEventListener('change', this.update);
      this.reducedMotion.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.update);

      this.slideObserver = new MutationObserver(this.update);
      this.slideObserver.observe(this.slide, { attributes: true, attributeFilter: ['class'] });
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.syncPlayback();
      });
      this.visibilityObserver.observe(this);
    }

    disconnectedCallback() {
      this.slideObserver.disconnect();
      this.visibilityObserver.disconnect();
      this.mobile.removeEventListener('change', this.update);
      this.reducedMotion.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.update);
      this.removeVideo();
    }

    removeVideo() {
      if (!this.video) return;
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.querySelectorAll('source').forEach((source) => source.remove());
      this.video.load();
      this.video.remove();
      this.video = null;
    }

    syncPlayback() {
      const viewport = this.mobile.matches ? 'mobile' : 'desktop';
      if (viewport !== this.viewport) {
        this.removeVideo();
        this.viewport = viewport;
      }

      const shouldPlay = this.visible && this.slide.classList.contains('is-active')
        && !document.hidden && !this.reducedMotion.matches;
      if (!shouldPlay) {
        if (this.video) this.video.pause();
        return;
      }

      // Keep sources inert until this slide and the matching viewport are visible.
      if (!this.video) {
        const template = this.querySelector(`template[data-viewport="${viewport}"]`);
        if (!template) return;
        this.video = template.content.querySelector('video').cloneNode(true);
        this.video.muted = true;
        this.video.tabIndex = -1;
        this.append(this.video);
      }
      this.video.play().catch(() => {
        // The cover image remains visible if the browser prevents autoplay.
      });
    }
  }

  customElements.define('slideshow-video', SlideshowVideo);
}
